
import { Link } from "react-router-dom";

interface LogoProps {
  className?: string;
}

const Logo = ({ className = "" }: LogoProps) => {
  return (
    <Link to="/" className={`block w-auto ${className}`}>
      <img 
        src="/images/logo-black.png" 
        alt="Kaija Alliksaar Coaching" 
        className="w-full h-auto" 
      />
    </Link>
  );
};

export default Logo;
